export const navLinks = [
  { label: '首页', href: '#top' },
  { label: '热点爆料', href: '#featured' },
  { label: '题材合集', href: '#topics' },
  { label: '事件脉络', href: '#timeline' },
  { label: '热门榜单', href: '#ranking' },
];

export const heroStats = [
  { value: '12,860+', label: '已收录爆料条目' },
  { value: '24 小时', label: '热点更新节奏' },
  { value: '38 个', label: '覆盖题材领域' },
];

export const tickerItems = [
  '顶流艺人工作室解散传闻再起，团队凌晨发布简短说明',
  '新能源车企三季度财报出炉，毛利率变化引行业讨论',
  '头部主播带货翻车事件持续发酵，平台已介入核查',
  '影视剧组片场纠纷视频流出，制片方回应时间线',
  '内容平台算法改版，创作者集体反馈流量波动',
  '老牌餐饮连锁被曝加盟争议，加盟商联合发声',
  '独立音乐人版权纠纷进入调解阶段，双方各执一词',
  '高校科研经费公示引发关注，校方发布情况说明',
];

export const featuredPosts = [
  {
    id: 'featured-1',
    tag: '娱乐爆料',
    title: '顶流合约风波：从一条深夜动态到行业连锁反应',
    excerpt:
      '从艺人深夜的一条动态开始，经纪团队、品牌方与平台方接连被卷入。44黑料区把散落各处的信息按时间顺序重新拼合，还原这场风波里每一次表态背后的关键节点。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20abstract%20spotlight%20glow%20with%20scattered%20paper%20confetti%20shapes%20in%20warm%20red%20orange%20and%20gold%20tones%20on%20a%20soft%20cream%20studio%20background%2C%20minimal%20editorial%20still%20life%2C%20subtle%20film%20grain%2C%20no%20text%2C%20clean%20negative%20space%2C%20balanced%20composition%2C%20high%20detail%20art%20direction&width=1200&height=1000&seq=hl-featured-01&orientation=landscape',
    readTime: '6 分钟读完',
    heat: '9.8 万人在看',
    comments: '2,140 条讨论',
  },
  {
    id: 'featured-2',
    tag: '社会民生',
    title: '旧城改造补偿争议：三个月里的三次协调会',
    excerpt:
      '补偿方案、评估标准与居民诉求之间的分歧，在一次又一次协调会上被逐条摆开。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20paper%20cutout%20city%20skyline%20and%20layered%20geometric%20blocks%20in%20warm%20amber%20terracotta%20and%20cream%20tones%20on%20a%20light%20background%2C%20minimal%20editorial%20illustration%2C%20soft%20film%20grain%2C%20no%20text%2C%20clean%20composition%2C%20high%20detail&width=900&height=700&seq=hl-featured-02&orientation=landscape',
    readTime: '4 分钟读完',
    heat: '4.3 万人在看',
    comments: '860 条讨论',
  },
  {
    id: 'featured-3',
    tag: '财经商界',
    title: '新消费品牌资金链传闻：门店闭店与加盟商回应',
    excerpt:
      '门店陆续调整、供应商账期拉长，市场关于资金链的猜测与品牌方的回应针锋相对。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20ascending%20stacked%20paper%20strips%20and%20small%20golden%20geometric%20accents%20in%20warm%20ochre%20and%20cream%20tones%20on%20a%20soft%20neutral%20background%2C%20minimal%20editorial%20collage%2C%20subtle%20grain%2C%20no%20text%2C%20generous%20negative%20space%2C%20high%20detail&width=900&height=700&seq=hl-featured-03&orientation=landscape',
    readTime: '5 分钟读完',
    heat: '3.6 万人在看',
    comments: '512 条讨论',
  },
];

export const topicCollections = [
  {
    id: 'topic-1',
    name: '娱乐爆料',
    description: '艺人动态、剧组内幕与作品争议的集中整理',
    count: '3,240 条',
    icon: 'ri-mic-line',
  },
  {
    id: 'topic-2',
    name: '社会民生',
    description: '城市建设、消费维权与公共事件的过程还原',
    count: '2,180 条',
    icon: 'ri-building-2-line',
  },
  {
    id: 'topic-3',
    name: '财经商界',
    description: '企业经营、资本动作与行业传闻的交叉验证',
    count: '1,760 条',
    icon: 'ri-line-chart-line',
  },
  {
    id: 'topic-4',
    name: '网络热点',
    description: '平台规则、网红争议与流量事件的脉络梳理',
    count: '2,930 条',
    icon: 'ri-global-line',
  },
  {
    id: 'topic-5',
    name: '体育竞技',
    description: '赛事争议、转会传闻与队伍管理的公开信息',
    count: '980 条',
    icon: 'ri-basketball-line',
  },
  {
    id: 'topic-6',
    name: '科技数码',
    description: '新品发布、产品争议与厂商回应的时间线',
    count: '1,420 条',
    icon: 'ri-cpu-line',
  },
];

export const eventTimeline = {
  title: '一条爆料的完整脉络',
  subtitle: '以「新能源车企财报」事件为例，44黑料区把关键节点按时间顺序整理成一条可回溯的线索。',
  steps: [
    {
      time: '09 月 08 日',
      title: '财报数据公布',
      desc: '企业发布季度财报，毛利率环比变化超出市场预期，相关讨论首次集中出现。',
      tag: '事件起点',
    },
    {
      time: '09 月 09 日',
      title: '行业分析师解读',
      desc: '多位分析师给出不同判断，观点分歧把话题推向更大范围的讨论。',
      tag: '观点交锋',
    },
    {
      time: '09 月 10 日',
      title: '供应链侧爆料流出',
      desc: '部分供应商账期与订单调整的信息被披露，围绕资金状况的猜测增多。',
      tag: '信息补充',
    },
    {
      time: '09 月 11 日',
      title: '企业首次正式回应',
      desc: '企业通过官方渠道说明经营与现金流情况，并对部分传闻作出直接否认。',
      tag: '官方回应',
    },
    {
      time: '09 月 12 日',
      title: '最新进展汇总',
      desc: '行业协会表示关注，多方信息继续交叉验证，事件仍在持续更新中。',
      tag: '持续更新',
    },
  ],
};

export const rankingList = [
  { rank: 1, title: '顶流工作室解散传闻与深夜说明', category: '娱乐', heat: '98.6' },
  { rank: 2, title: '新能源车企财报背后的毛利率之争', category: '财经', heat: '92.4' },
  { rank: 3, title: '头部主播带货翻车，平台介入核查', category: '网络', heat: '88.1' },
  { rank: 4, title: '旧城改造补偿争议的三次协调会', category: '社会', heat: '81.7' },
  { rank: 5, title: '影视剧组片场纠纷视频与双方回应', category: '娱乐', heat: '77.9' },
  { rank: 6, title: '新消费品牌资金链传闻持续发酵', category: '财经', heat: '71.3' },
  { rank: 7, title: '内容平台算法改版引发创作者反馈', category: '科技', heat: '66.5' },
  { rank: 8, title: '老牌餐饮加盟争议与加盟商联合声明', category: '社会', heat: '61.2' },
  { rank: 9, title: '独立音乐人版权纠纷进入调解阶段', category: '娱乐', heat: '56.8' },
  { rank: 10, title: '高校科研经费公示引发的情况说明', category: '社会', heat: '52.4' },
];

export const footerLinks = [
  {
    title: '浏览',
    links: [
      { label: '热点爆料', href: '#featured' },
      { label: '题材合集', href: '#topics' },
      { label: '事件脉络', href: '#timeline' },
      { label: '热门榜单', href: '#ranking' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '站点说明', href: '#top' },
      { label: '内容规范', href: '#top' },
      { label: '纠错反馈', href: '#top' },
      { label: '更新日志', href: '#top' },
    ],
  },
];